/**
 * @author Andrés Camilo Ferreira Rodríguez
 * @Copyright (c) Infotrack. All rights reserved.
 */
import React from 'react';

import { useProveedor } from '@infotrack/presentacion-componentes/proveedorEstado';
import Texto from '@infotrack/presentacion-componentes/texto';
import { TipoFormulario } from '@infotrack/presentacion-transversales/interfacesComunes';
import {
    manejadorDialogoGlobal,
    manejadorIndicadorCargaGlobal,
} from '@infotrack/presentacion-utilitarios/manejadoresComponentes';

import IUnidadCompleta from 'Infotrack@Modelos/smartStock/unidades/entidades/unidadCompleta';
import IUnidades from 'Infotrack@Modelos/smartStock/unidades/entidades/unidades';
import UnidadesCM from '../controladorModelo/unidadesCM';
import { acciones, IEstadoUnidades } from '../reductorUnidades';
import UnidadesVista from '../vista/tablaUnidadesVista';
import { useSelector } from 'react-redux';
import { IEstadoGlobal } from 'Infotrack@Reductores/interfacesReductores';

const unidadesCM = new UnidadesCM();

const TableUnidadesCV: React.FunctionComponent = () => {
    const cargaInicial = React.useRef(true);
    const [unidadess, setUnidadess] = React.useState<IUnidadCompleta[]>([]);
    const [{ recargarTabla }, dispatch] = useProveedor<IEstadoUnidades>();
    const idEmpresa = useSelector((e: IEstadoGlobal) => e.estadoAutenticacion.usuarioInformacion!.IdEmpresa);
    React.useEffect(() => {
        if (recargarTabla || cargaInicial.current) {
            cargarUnidades();
            if (recargarTabla) {
                dispatch({ type: acciones.RECARGAR_TABLA });
            }
        }
        cargaInicial.current = false;
    });

    const cargarUnidades = () => {
        manejadorIndicadorCargaGlobal(true);
        unidadesCM.consultarUnidadesPorEmpresa({ EmpresaId: idEmpresa }).then((unidadess) => {
            setUnidadess(
                unidadess.map((obj) => ({
                    ...obj,
                    TipoUnidad: {
                        TipoUnidadId: obj.TipoUnidadId,
                        DescripcionTipoUnidad: obj.DescripcionTipoUnidad,
                        EmpresaId: '',
                        AgenciaId: '',
                        Estado: 1,
                    },
                }))
            );
            manejadorIndicadorCargaGlobal(false);
        });
    };
    const manejarFormulario = (tipoFormulario: TipoFormulario, entidadUnidades?: IUnidades) => {
        dispatch({ type: acciones.CAMBIAR_ESTADO_FORMULARIO, payload: { entidadUnidades, tipoFormulario } });
    };

    const confirmarEliminacion = (unidades: IUnidades) => {
        manejadorDialogoGlobal({
            accionCancelar: () => manejadorDialogoGlobal({ estado: false }),
            accionConfirmar: () => eliminarUnidades(unidades),
            estado: true,
            mensaje: <Texto id={'alerta.confirmacionEliminacion'} />,
            mostrarCancelar: true,
            tipoDialogo: 'Advertencia',
            titulo: <Texto id="titulo.advertencia" />,
        });
    };

    const eliminarUnidades = (unidades: IUnidades) => {
        manejadorIndicadorCargaGlobal(true);
        manejadorDialogoGlobal({ estado: false });
        unidadesCM.eliminarUnidades(unidades).then(() => {
            manejadorIndicadorCargaGlobal(false);
            dispatch({ type: acciones.RECARGAR_TABLA });
        });
    };

    return (
        <UnidadesVista
            unidadess={unidadess}
            cargarUnidades={cargarUnidades}
            confirmarEliminacion={confirmarEliminacion}
            manejarFormulario={manejarFormulario}
        />
    );
};

export default TableUnidadesCV;
